import { defineStore } from 'pinia'
import { useCacheStore } from '~/store/cache'
import { usePageStore } from '~/store/page'
import { useCmsFetch, useGraphqlFetch } from '~/composables/craft-fetch'

export const useAnimalStore = defineStore('animal', () => {
  const cacheStore = useCacheStore()
  const pageStore = usePageStore()
  const cmsFetch = useCmsFetch()
  const graphqlFetch = useGraphqlFetch()

  async function fetchAnimalCounts(site: string, animalType: string) {
    const key = `animal-facets;site:${site};animalType:${animalType}`
    const ttl = 3

    const fetcher = async () => {
      const { elasticSearch } = await graphqlFetch({
        query: `query fetchAnimalCategories($site: [String], $animalType: [String]) {
          elasticSearch(section: "animal", site: $site, animalTypeFacet: $animalType) {
            facets {
              animalCategory {
                value
                count
              }
            }
          }
        }`,
        variables: {
          site,
          animalType,
        },
        params: { animalCategory: animalType },
        token: 'elasticsearch',
      })

      return Object.fromEntries(elasticSearch.facets.animalCategory.map(({ value, count }) => [value, count]))
    }

    return await cacheStore.fetch({ key, ttl, fetcher })
  }

  async function fetchAnimal(id: string, push: boolean, options: any) {
    const key = `animal;id:${id}`
    const ttl = 300

    const fetcher = async () => {
      return await cmsFetch(`/api/animal/${id}.json`, { ...options })
    }

    const page = await cacheStore.fetch({ key, ttl, fetcher })
    if (push && page) {
      pageStore.setPage(page)
    }

    return page
  }

  return { fetchAnimalCounts, fetch: fetchAnimal }
})
